import { sharedSubTasksFetchActionHandler } from "./sharedSubTasks/sharedSubTasks";
import {
  allTasksFetchActionHandler,
  allTasksByIdFetchActionHandler,
  allTasksCreateActionHandler,
  allTasksUpdateActionHandler,
  allTasksDeleteActionHandler,
} from "./allTasks/allTasks";

import {
  subTasksFetchActionHandler,
  subTasksByIdFetchActionHandler,
  subTasksCreateActionHandler,
  subTasksUpdateActionHandler,
  subTasksDeleteActionHandler,
} from "./subTasks/subTasks";

import {
  ownTasksFetchActionHandler,
  ownTasksByIdFetchActionHandler,
  ownTasksCreateActionHandler,
  ownTasksUpdateActionHandler,
  ownTasksDeleteActionHandler,
} from "./ownTasks/ownTasks";

import {
  assignedTasksFetchActionHandler,
  assignedTasksByIdFetchActionHandler,
  assignedTasksCreateActionHandler,
  assignedTasksUpdateActionHandler,
  assignedTasksDeleteActionHandler,
} from "./assignedTasks/assignedTasks";

import {
  assignedSubTasksFetchActionHandler,
  assignedSubTasksByIdFetchActionHandler,
  assignedSubTasksCreateActionHandler,
  assignedSubTasksUpdateActionHandler,
  assignedSubTasksDeleteActionHandler,
} from "./assignedSubTasks/assignedSubTasks";

import {
  sharedTasksFetchActionHandler,
  sharedTasksByIdFetchActionHandler,
  sharedTasksCreateActionHandler,
  sharedTasksUpdateActionHandler,
  sharedTasksDeleteActionHandler,
} from "./sharedTasks/sharedTasks";

import {
  priorityFetchActionHandler,
  priorityByIdFetchActionHandler,
  priorityCreateActionHandler,
  priorityUpdateActionHandler,
  priorityDeleteActionHandler,
} from "./settings/priority/priority";

import {
  statusFetchActionHandler,
  statusByIdFetchActionHandler,
  statusCreateActionHandler,
  statusUpdateActionHandler,
  statusDeleteActionHandler,
} from "./settings/status/status";

const taskManagementActionsHandlers = {
  // all tasks
  allTasksFetchActionHandler,
  allTasksByIdFetchActionHandler,
  allTasksCreateActionHandler,
  allTasksUpdateActionHandler,
  allTasksDeleteActionHandler,

  // sub tasks
  subTasksFetchActionHandler,
  subTasksByIdFetchActionHandler,
  subTasksCreateActionHandler,
  subTasksUpdateActionHandler,
  subTasksDeleteActionHandler,

  //own tasks
  ownTasksFetchActionHandler,
  ownTasksByIdFetchActionHandler,
  ownTasksCreateActionHandler,
  ownTasksUpdateActionHandler,
  ownTasksDeleteActionHandler,

  // assigned tasks
  assignedTasksFetchActionHandler,
  assignedTasksByIdFetchActionHandler,
  assignedTasksCreateActionHandler,
  assignedTasksUpdateActionHandler,
  assignedTasksDeleteActionHandler,

  // assigned sub tasks
  assignedSubTasksFetchActionHandler,
  assignedSubTasksByIdFetchActionHandler,
  assignedSubTasksCreateActionHandler,
  assignedSubTasksUpdateActionHandler,
  assignedSubTasksDeleteActionHandler,

  // shared sub tasks
  sharedSubTasksFetchActionHandler,

  // shared tasks
  sharedTasksFetchActionHandler,
  sharedTasksByIdFetchActionHandler,
  sharedTasksCreateActionHandler,
  sharedTasksUpdateActionHandler,
  sharedTasksDeleteActionHandler,

  //  settings
  // priority
  priorityFetchActionHandler,
  priorityByIdFetchActionHandler,
  priorityCreateActionHandler,
  priorityUpdateActionHandler,
  priorityDeleteActionHandler,

  // status
  statusFetchActionHandler,
  statusByIdFetchActionHandler,
  statusCreateActionHandler,
  statusUpdateActionHandler,
  statusDeleteActionHandler,
};

export default taskManagementActionsHandlers;
